import { CircularProgress } from '@mui/material'
import Container from '@mui/material/Container'
import React, { useState } from 'react'
import * as Yup from 'yup'

import Form from './form'
import schema from './form/schema'
import { convertToSheetData, generateSpreadSheet } from './utils'
import {
  Event as EventApi,
  FormEvent as FormEventApi,
  FormParticipant as FormParticipantApi,
  Participant,
} from '../../../API'
import Page from '../../../components/elements/Page'
import EmptyState from '../../../components/EmptyState'
import Section from '../../../components/Section'
import { listParticipantsByEvent } from '../../../hooks/listParticipantsByEvent'
import {
  useEventsForDownload,
  getEventForDownload,
} from '../../../hooks/useEventsForDownload'

interface Props {}

type Event = Omit<Exclude<EventApi, null>, '__typename'> & {
  isFP?: boolean
}
type FormEvent = Omit<Exclude<FormEventApi, null>, '__typename'> & {
  isFP?: boolean
}
type FormParticipant = Omit<Exclude<FormParticipantApi, null>, '__typename'> & {
  tshirtCountTotal: number
}

const DownloadParticipants: React.FC<Props> = () => {
  const [isGenerating, setIsGenerating] = useState(false)

  const { events, apiLoading, apiError } = useEventsForDownload()

  const handleSubmit = async (values: Yup.InferType<typeof schema>) => {
    setIsGenerating(true)
    let selectedEvent =
      events.filter(
        (event: Event | FormEvent) => event.id === values.eventId,
      )?.[0] || null

    if (!selectedEvent)
      selectedEvent = await getEventForDownload(values.eventId.toLowerCase())

    if (selectedEvent) {
      const results = await listParticipantsByEvent({
        eventId: selectedEvent.id,
        isFormParticipant: !!(selectedEvent as FormEvent).isFP,
      })
      const sheetData = convertToSheetData(
        selectedEvent.id,
        results.participants as Participant[] | FormParticipant[],
      )
      generateSpreadSheet({
        event: selectedEvent,
        isFP: !!(selectedEvent as FormEvent).isFP,
        data: sheetData,
        formShirtData: results.shirtTotal,
      })
    }
    setIsGenerating(false)
  }

  return (
    <>
      {apiLoading && <CircularProgress />}
      {apiError && (
        <div style={{ textAlign: 'center' }}>
          <EmptyState
            header={apiError.title}
            text={apiError.message}></EmptyState>
        </div>
      )}

      {!apiLoading && (
        <Section>
          <Page noPadding>
            <Container maxWidth="sm">
              <Form
                onSubmit={handleSubmit}
                events={events}
                loading={apiLoading || isGenerating}
              />
            </Container>
          </Page>
        </Section>
      )}
    </>
  )
}

export default DownloadParticipants
